import { isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { DealerProfileService } from './dealer-profile.service';
import { catchError, take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import * as HttpStatus from 'http-status-codes';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "./dealer-profile.service";
import * as i2 from "@angular/router";
import * as i3 from "../../../shared/services/authentication.service";
var DealerProfileResolver = /** @class */ (function () {
    function DealerProfileResolver(reader, router, authenticator) {
        this.reader = reader;
        this.router = router;
        this.authenticator = authenticator;
    }
    DealerProfileResolver.prototype.resolve = function (route, state) {
        var _this = this;
        return this.reader
            .getDealerProfile(route.params.dealerId)
            .pipe(take(1), catchError(function (error) {
            if (isDevMode()) {
                console.error('Dealer Profile error: ', error);
            }
            if ((error instanceof HttpErrorResponse) && (error.status === HttpStatus.UNAUTHORIZED)) {
                if (_this.authenticator.isLoggedIn()) {
                    _this.authenticator.clearSession();
                }
                var returnURL = _this.router.routerState.snapshot.url;
                _this.router.navigate(['/login'], { queryParams: { returnUrl: returnURL } });
                return Promise.resolve(null);
            }
            else {
                return Promise.reject(error.message || error);
            }
        }));
    };
    DealerProfileResolver.ngInjectableDef = i0.defineInjectable({ factory: function DealerProfileResolver_Factory() { return new DealerProfileResolver(i0.inject(i1.DealerProfileService), i0.inject(i2.Router), i0.inject(i3.AuthenticationService)); }, token: DealerProfileResolver, providedIn: "root" });
    return DealerProfileResolver;
}());
export { DealerProfileResolver };
